import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=5308414c&scoped=true&"
import script from "./DesktopNav.vue?vue&type=script&lang=js&"
export * from "./DesktopNav.vue?vue&type=script&lang=js&"
import style0 from "./DesktopNav.vue?vue&type=style&index=0&id=5308414c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5308414c",
  null
  
)

export default component.exports